<template>
  <div>
    <base-header class="pb-8 pt-4" />
    <div class="container-fluid mt--7">
      <appointment-card />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import request from '../../request';
import { required } from 'vuelidate/lib/validators';
import moment from 'moment';
import AppointmentCard from '../../components/AppointmentCard';

export default {
  name: 'AppointmentList',
  components: { AppointmentCard },
};
</script>
